module.exports = __webpack_public_path__ + "img/ms-exchange-logo.912d5dea.svg";